var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { useCallback, useEffect, useState } from "react";

var check_webp_feature = function (feature, callback) {
  var kTestImages = {
    lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
    lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
    alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
    animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
  };
  var img = new Image();

  img.onload = function () {
    var result = img.width > 0 && img.height > 0;
    callback(feature, result);
  };

  img.onerror = function () {
    callback(feature, false);
  };

  img.src = "data:image/webp;base64," + kTestImages[feature];
};

var checkPromise = function () {
  return new Promise(function (reslove) {
    check_webp_feature("lossy", function (feature, isSupported) {
      if (isSupported) {
        reslove(true);
      } else {
        reslove(false);
      }
    });
  });
};

var spliceLastFlag = function (url) {
  var length = url.length;

  if (url.slice(length - 1) === "|") {
    url = url.slice(0, length - 1);
  }

  return url;
};

export var useCDN = function (_a) {
  var width = _a.width,
      height = _a.height,
      src = _a.src,
      _b = _a.options,
      options = _b === void 0 ? {} : _b,
      _c = _a.open,
      open = _c === void 0 ? false : _c;

  var _d = useState(undefined),
      cdnSrc = _d[0],
      setCdnSrc = _d[1];

  var _e = useState({
    isImage2: false,
    isPiple: false,
    lastFlag: false,
    url: ""
  }),
      feature = _e[0],
      setFeature = _e[1];

  var resetUrl = useCallback(function (url) {
    if (!url) return "";
    var isImage2 = false;
    var isPiple = false;
    var lastFlag = false;

    if (url.indexOf("imageView2/") !== -1) {
      isImage2 = true;
    }

    if (url.indexOf("watermark/") !== -1 || url.indexOf("imageMogr2") !== -1) {
      isPiple = true;
    }

    var length = url.length;

    if (url.slice(length - 1) === "|") {
      lastFlag = true;
    }

    setFeature({
      isImage2: isImage2,
      isPiple: isPiple,
      lastFlag: lastFlag,
      url: url.indexOf("?") > -1 ? url : "".concat(url, "?")
    });
  }, []);
  var handleImageView2 = useCallback(function (url) {
    if (url === void 0) {
      url = "";
    }

    return __awaiter(void 0, void 0, void 0, function () {
      var _a, mode, w, h, q, webp, params;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = getSearchs(), mode = _a.mode, w = _a.w, h = _a.h, q = _a.q;
            return [4
            /*yield*/
            , handleWebp()];

          case 1:
            webp = _b.sent();
            params = "".concat(feature.isPiple && !feature.lastFlag ? "|" : "", "imageView2/").concat(mode, "/w/").concat(w, "/h/").concat(h, "/q/").concat(q, "/format/").concat(webp);
            setCdnSrc(spliceLastFlag("".concat(url).concat(params)));
            return [2
            /*return*/
            ];
        }
      });
    });
  }, [feature]);
  var handleReplace = useCallback(function (url) {
    if (url === void 0) {
      url = "";
    }

    return __awaiter(void 0, void 0, void 0, function () {
      var _a, w, h, q, mode, webp, parmas, regex, regexWithFlag;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = getSearchs(), w = _a.w, h = _a.h, q = _a.q, mode = _a.mode;
            return [4
            /*yield*/
            , handleWebp()];

          case 1:
            webp = _b.sent();
            parmas = "imageView2/".concat(mode, "/w/").concat(w, "/h/").concat(h, "/q/").concat(q, "/format/").concat(webp);
            regex = /imageView2.*/;
            regexWithFlag = /imageView2.*\|/;

            if (regexWithFlag.test(url)) {
              url = url.replace(regexWithFlag, "".concat(parmas, "|"));
            } else {
              url = url.replace(regex, "".concat(parmas));
            }

            setCdnSrc(spliceLastFlag(url));
            return [2
            /*return*/
            ];
        }
      });
    });
  }, []);
  var handleWebp = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var supporWebp;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , checkPromise()];

          case 1:
            supporWebp = _a.sent();
            return [2
            /*return*/
            , supporWebp ? "webp" : ""];
        }
      });
    });
  }, []);
  var getSearchs = useCallback(function () {
    var _a, _b, _c, _d;

    var mode = (options === null || options === void 0 ? void 0 : options.mode) || 2;
    var magnify = (options === null || options === void 0 ? void 0 : options.magnify) || 3;
    var quality = (options === null || options === void 0 ? void 0 : options.quality) || 75;
    return {
      mode: mode,
      w: width ? (_b = (_a = Number(width) * magnify) === null || _a === void 0 ? void 0 : _a.toFixed) === null || _b === void 0 ? void 0 : _b.call(_a, 0) : 0,
      h: height ? (_d = (_c = Number(height) * magnify) === null || _c === void 0 ? void 0 : _c.toFixed) === null || _d === void 0 ? void 0 : _d.call(_c, 0) : 0,
      q: quality
    };
  }, [width, height, options]);
  useEffect(function () {
    open && src && resetUrl(src);
  }, [src, open]);
  useEffect(function () {
    if (src && open) {
      if (feature.isImage2) {
        feature.url && handleReplace(feature.url);
      } else {
        feature.url && handleImageView2(feature.url);
      }
    }
  }, [src, width, height, feature, open]); // useEffect(() => console.log("#cdn src#", cdnSrc), [cdnSrc]);

  return [cdnSrc];
};